import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"
import axios from "axios"

const initialState = {
    data: null,
    loading: false,
    error: null,
   
}

export const GetOrders = createAsyncThunk(
    "GetOrders",
    async (body) => {
        try {
            const response = await instance.get(`/remark/order/order-list?page=${body.page}&search=${body.search}`);
            return response?.data;
            
        } catch (error) {
            throw error
        }
    }
)

export const OrderSlice = createSlice({
    name: "OrderSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(GetOrders.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(GetOrders.fulfilled, (state, action) => {
        
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(GetOrders.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })


    }
})

export default OrderSlice.reducer;